import { Switch } from "@mui/material"
import { styled } from "@mui/material/styles"

export const OneSwitch = styled(({ name, defaultValue, defaultChecked, ballWidth, ballHeight, ...rest }) => {
    return (
        <Switch
            name={name}
            focusVisibleClassName=".Mui-focusVisible"
            defaultChecked={defaultChecked || defaultValue}
            disableRipple
            {...rest}
        />
    )
})(({ theme, ball = 10 }) => ({
    width: 30,
    height: 15,
    padding: 0,
    margin: 0,
    // left: '12px',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(15px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#6EAE0B',
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '1px solid #fff'
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: ball,
        height: ball
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#FA5D5D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}))
